var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_286",
    "data-name": "Group 286",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18.509,
    height: 18.505,
    viewBox: "0 0 18.509 18.505",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_156",
    "data-name": "Rectangle 156",
    width: 18.509,
    height: 18.505,
    fill: "#9da1b2"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_285",
    "data-name": "Group 285",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_540",
    "data-name": "Path 540",
    d: "M17.154,1.355C15.8,0,13.617,0,9.255,0s-6.544,0-7.9,1.355S0,4.892,0,9.255s0,6.544,1.355,7.9c1.155,1.155,2.909,1.326,6.1,1.351V9.742a1.8,1.8,0,0,1,3.6,0V18.5c3.192-.025,4.946-.2,6.1-1.351,1.355-1.355,1.355-3.537,1.355-7.9s0-6.544-1.355-7.9m-7.9,4.4a1.964,1.964,0,1,1,1.964-1.964A1.964,1.964,0,0,1,9.255,5.758",
    fill: "#9da1b2",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.8c9d935033ed63d29b2ea56674456795.svg";
export { ForwardRef as ReactComponent };